import { useFeatureIsOn } from '@growthbook/growthbook-react'
import React, { useState } from 'react'
import { Tabs, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { Navigator } from 'modules/core/components'
import { SiderLayout } from 'modules/core/layouts'
import { RulesList, CurrencyList } from '../'
import { isUserAllowed, getOperationsByKeys } from 'modules/core/utils'
import { ROLES } from 'modules/core/constants'
import { useParams } from 'react-router-dom'

const { SETTINGS__PROJECTION_ELEMENTS__BUSINESS_RULES, SETTINGS__PROJECTION_ELEMENTS__CURRENCY } =
  ROLES

const ModificadoresHome = () => {
  const enabled = useFeatureIsOn('feature-moneda-seguimiento')
  let { type } = useParams()
  const [tabKey, setTabKey] = useState(type || 'rules')
  const { t } = useTranslation()

  const renderHeader = () => (
    <Navigator
      floated={false}
      size="big"
      items={[
        {
          name: t('LABEL_CONFIG'),
          url: `/configuracion`,
        },
        { name: t('LABEL_TOOLS') },
      ]}
    />
  )

  const handleClick = (key) => {
    setTabKey(key)
    window.history.replaceState(null, '', `/configuracion/herramientas/${key}`)
  }

  return (
    <SiderLayout>
      <>
        {renderHeader()}
        <Tabs
          size="small"
          defaultActiveKey={tabKey}
          style={{ paddingTop: 24 }}
          onChange={handleClick}
        >
          {isUserAllowed(getOperationsByKeys([SETTINGS__PROJECTION_ELEMENTS__BUSINESS_RULES])) && (
            <Tabs.TabPane
              tab={
                <Tooltip title={t('CONFIG_RULES_INFORMATIVE_TOOLTIP_TITLE')}>
                  {t('LABEL_BUSINESS_RULES')}
                </Tooltip>
              }
              key="rules"
            >
              <RulesList />
            </Tabs.TabPane>
          )}
          {
            // isUserAllowed(
            //   getOperationsByKeys([SETTINGS__PROJECTION_ELEMENTS__CURRENCY])
            // ) && (
            enabled && (
              <Tabs.TabPane
                tab={
                  <Tooltip title={t('CONFIG_CURRENCY_INFORMATIVE_TOOLTIP_TITLE')}>
                    {t('LABEL_CURRENCY')}
                  </Tooltip>
                }
                key="currency"
              >
                <CurrencyList />
              </Tabs.TabPane>
            )
            // )
          }
        </Tabs>
      </>
    </SiderLayout>
  )
}

export default ModificadoresHome
